<template>
    <label class="v-form-switch unselectable" :class="{\'disabled\': disabled}">
        <input type="checkbox" v-model="checked" :disabled="disabled">
        <i class="icon"></i>
        <slot></slot>
    </label>
</template>

<script lang="babel">
    /**
     * Created by Pan on 16/5/23.
     *
     * 开关 参考自: http://picturepan2.github.io/spectre/#forms
     *
     * <switch :checked="checked" label="显示评语" @update="update()"></switch>
     */
    import './form.styl'
    export default{
        props: {
            /**
             * 选中状态
             * 设计合理的第三方组件应该尽量避免 mutate 传进去的 props，而是通过 emit 事件来和外界通信
             * 任何 mutate props 的第三方组件都没有 follow 最佳实践
             */
            checked: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            checked(val) {
                this.$dispatch('update', val)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// toggle.vue?bc8917b4